import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { FormGroup, Label, Input } from 'reactstrap';

import SingleErrorDisplay from '../../../../_components/error-display/single-error-display';
import { useFormFieldContext } from '../../../../_components/form-hook';

export default function MVPDiagnosisCodes() {
  const label = 'Diagnosis Code(s)';
  const required = true;
  const name = 'diagnosisCodes';
  const {
    value,
    isValid,
    isNotValid,
    setValue: setFieldValue,
  } = useFormFieldContext(name);
  const { trigger } = useFormContext();
  const onChange = useCallback(
    (event: any) => {
      const val = event.target.value as string;
      const values = val.split(',').map((m) => m.trim());
      if (isEmpty(values.at(-1))) {
        values.pop();
      }
      setFieldValue(values, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    },
    [setFieldValue]
  );
  return (
    <FormGroup>
      {label ? (
        <Label className={cx({ required, stay: value })} for={name}>
          {label}
        </Label>
      ) : null}
      <Input
        id={name}
        onChange={onChange}
        onBlur={() => trigger('diagnosisCodes')}
        defaultValue={value || ''}
        valid={isValid}
        invalid={isNotValid}
        type="text"
        name={name}
        className={cx('form-control mb-2')}
        autoComplete="off"
        aria-required={required}
        placeholder="Comma separated list of diagnosis codes. Max 12."
      />
      <SingleErrorDisplay field={name} />
    </FormGroup>
  );
}
